<template>
  <!-- Questionaire -->
    <div id="stage-2" class="page text-left question-page mt-0 p-4 container">
        <b-form id="questionsForm" class="col-sm-12 col-md-8 m-auto" @submit.prevent>
                <div class="row mb-4">
                  <div class="col-8 my-auto"><h4>About you</h4> <p style="font-size:.8rem;" :class="{error:!validForm}">(All responses mandatory)</p></div>
                  <div  class="col-4 d-flex justify-content-end"><span @click="closeQuestionaire()" class="close-btn"></span></div>
                </div>
                <div class="form-group col-sm-12 col-md-6">
                        <label for="inputAge">Age</label>
                        <b-form-select id="inputAge" v-model="form.age" class="form-control" aria-required="">
                          <option class="text-green" value="" selected disabled>Please select</option>
                          <option value="5-18">5-18</option> 
                          <option value="19-25">19-25</option>
                          <option value="26-45">26-45</option>
                          <option value="46-65">46-65</option>
                          <option value="66+">66+</option>
                        </b-form-select>
                </div>
                <div class="form-group col-sm-12 col-md-6">
                        <label for="inputGender">Gender</label>
                        <b-form-select id="inputGender" v-model="form.gender" class="form-control">
                          <option value="" selected disabled>Please select</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Neither. I identify as follows:</option>
                        </b-form-select>
                        <input v-if="form.gender.toLowerCase() == 'other' " type="text" autocomplete="off" v-model="form.genderDescription" class="form-control mt-2" id="inputGenderDesc" placeholder="">
                </div>
                <div class="form-group col-12">
                        <label for="inputEthnicity">Ethnicity</label>
                        <label class="descText">
                          Please note that the options below are taken from the 2011 UK Census. However, should you
                          prefer to define your ethnicity differently, you can do so by selecting ‘None of the above’ and typing in the additional text box.
                        </label>
                        <b-form-select id="inputEthnicity" v-model="form.ethnicity" class="form-control">
                          <option value="" selected disabled>Please select</option>
                          <optgroup label="White">
                                <option value="English/Welsh/Scottish/Northern Irish/British">English/Welsh/Scottish/Northern Irish/British</option>
                                <option value="Irish">Irish</option>
                                <option value="Gypsy or Irish Traveller">Gypsy or Irish Traveller</option>
                                <!-- <option value="Any other White background">Any other White background:</option>	 -->
                            </optgroup>
                            <optgroup label="Mixed/multiple ethnic groups">
                                <option value="White and Black Caribbean">White and Black Caribbean</option>
                                <option value="White and Black African">White and Black African</option>
                                <option value="White and Asian">White and Asian</option>
                                <!-- <option value="Any other Mixed/multiple ethnic background">Any other Mixed/multiple ethnic background:</option>									 -->
                            </optgroup>
                            <optgroup label="Asian/Asian British">
                                <option value="Indian">Indian</option>
                                <option value="Pakistani">Pakistani</option>
                                <option value="Bangladeshi">Bangladeshi</option>
                                <option value="Chinese">Chinese</option>
                                <!-- <option value="Any other Asian background">Any other Asian background:</option> -->
                            </optgroup>
                            <optgroup label="Black/African/Caribbean/Black British">
                                <option value="African">African</option>
                                <option value="Caribbean">Caribbean</option>
                                <!-- <option value="Any other Black/African/Caribbean background">Any other Black/African/Caribbean background:</option> -->
                            </optgroup>
                            <optgroup label="Other ethnic group">
                                <option value="Arab">Arab</option>
                                <option :value="formText.ethnicityText">{{formText.ethnicityText}}:</option>
                            </optgroup>
                        </b-form-select>
                        <input 
                          v-if="form.ethnicity.toLowerCase() == formText.ethnicityText.toLowerCase()"
                        type="text" autocomplete="off" v-model="form.ethnicityDescription" class="form-control mt-2" id="inputEthnicityDesc" placeholder="">
                </div>
                <div class="form-group col">
                    <label for="inputTown">Town/city and country of birth</label>
                    <input type="text" autocomplete="off" v-model="form.town" class="form-control" id="inputTown" aria-describedby="inputTownInfo" placeholder="(e.g., ‘Manchester, UK’)">
                </div>
                <div class="form-group col">
                        <label for="inputPostcode">Current postcode area</label>
                        <input type="text" autocomplete="off" v-model="form.postcode" class="form-control" id="inputPostcode" aria-describedby="inputTownInfo" placeholder="(enter the first part of your postcode, e.g., ‘M50’)">
                </div>
                <div class="col my-4">
                        <b-button v-on:click="submitQuestionaire()" id="submitQuestions" type="b-button" class="btn rounded-btn px-5">Submit and move to map <i class="icon-placeholder"></i></b-button>
                </div>
            </b-form>
    </div>
</template>

<style scoped>
select{
  color: rgba(255, 255, 255, 1) !important;
}

option{
  color: rgba(0, 0, 0, 1) !important;
}


optgroup{
  color: rgba(0, 0, 0, 1) !important;
}

.error{
  color: hsl(0, 95%, 42%);
  /* color: red; */
}
.close-btn{
  display: inline-block;
  height: 40px;
  width: 40px;
  background: transparent url("../assets/close-icon.png") 0 0 no-repeat;
  background-size: 25px;
  background-position: center;
  right: -7px;
  position: relative;
}

.close-btn:hover{
  background-size: 30px;
}

.icon-placeholder{
  display: inline-block;
  height: 10px;
  width: 10px;
  background: transparent url("../assets/arrow-icon.png") 0 0 no-repeat;
  background-size: contain;
  right: -7px;
  position: relative;
}
.rounded-btn{
  border-radius: 100px;
  background-color: rgb(0, 0, 0);
  color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, 1);
}

/* .rounded-btn:hover{
  border-radius: 100px;
  background-color: rgb(0, 0, 0);
  color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, 1);
} */
.descText{
  font-size: 0.9rem;
}
select,input{
  border-radius: 100px;
}
select{
  background-color: rgba(255,255,255,0) !important;
}


 .question-page{
   /* background-color: rgb(126, 126, 126);
   color: rgba(255,255,255,1) */
  /* height: 100vh;; */
 }
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



<script>
export default {
  name: "Questionaire",
  data(){
    return{
      form :{
      age : '',
      gender : '',
      genderDescription : '',
      ethnicity : '',
      ethnicityDescription : '',
      town : '',
      postcode : ''
      },
      validForm : true,
      formText:{
        ethnicityText : 'None of the above. I identify as follows',
        genderText :''
      }
    }
  },
  props: {
    msg: String
  },
  methods:{
    closeQuestionaire(){
      console.log('closing form');
      this.$emit('update:showQuestions',false)
    },
    submitQuestionaire(){

      //Check neither in form selection box is active
      if(this.form.ethnicity.toLowerCase() != this.formText.ethnicityText.toLowerCase()){
        this.form.ethnicityDescription = '';
      }

      if(this.form.gender.toLowerCase() != 'other'){
        this.form.genderDescription = '';
      }
      //End

      if(this.form.age && this.form.gender && this.form.ethnicity &&this.form.town && this.form.postcode){
        this.validForm = true;
        console.log('.....')
        this.$router.push({ name: 'map',params: {form : this.form}})
      }else{
        this.validForm = false;
      }

    }
  }
};
</script>